// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".aa[data-v-f37d3c0e]{background-color:#0ff;cursor:pointer}.search_block[data-v-f37d3c0e]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:end;-ms-flex-align:end;align-items:flex-end}.possion[data-v-f37d3c0e]{margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
